import { skipToken, useQuery } from "@tanstack/react-query";
import {
  getPartiesAccessRoleCodeCompanyNumberCompanyNumberAvailability,
  getPartiesCompanyNumberCompanyNumberAvailability,
  type Region,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const PARTY_COMPANY_NUMBER_AVAILABILITY_QUERY_KEY =
  "PARTY_COMPANY_NUMBER_AVAILABILITY";

export const getPartyCompanyNumberAvailabilityQueryKey = (
  accessRoleCode?: string | null,
  companyNumber?: string | null,
  region?: Region | null,
) => [
  PARTY_COMPANY_NUMBER_AVAILABILITY_QUERY_KEY,
  accessRoleCode,
  companyNumber,
  region,
];

export const usePartyCompanyNumberAvailabilityQuery = (
  companyNumber: string | null,
  {
    enabled,
    accessRoleCode,
    region,
  }: { enabled?: boolean; accessRoleCode?: string; region?: Region | null },
) =>
  useQuery({
    queryKey: getPartyCompanyNumberAvailabilityQueryKey(
      accessRoleCode,
      companyNumber,
      region,
    ),
    queryFn: companyNumber
      ? processResponseWithApiProblemDetails(() =>
          accessRoleCode
            ? getPartiesAccessRoleCodeCompanyNumberCompanyNumberAvailability(
                accessRoleCode,
                companyNumber,
                region,
              )
            : getPartiesCompanyNumberCompanyNumberAvailability(companyNumber),
        )
      : skipToken,
    enabled,
  });
